import { computed, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { statusCheck } from '@/api'
import { moveToNextRoute } from './useNextRoute'
import { useStore } from 'vuex'

export default function useStatusCheck() {
	const { push } = useRouter()
	const store = useStore()
	const isLoggedIn = computed(() => store.state.isLoggedIn)
	onBeforeMount(async () => {
		if (!isLoggedIn.value) return push('/')
		const { status, data } = await statusCheck()
		if (status === 403) {
			push('/')
		} else if (status === 200) {
			store.commit('SET_DATA_BY_KEY', data)
			moveToNextRoute(data.status)
		}
	})
	return {
		isLoggedIn,
	}
}
